import React from 'react'
import { useTranslation } from 'react-i18next'

const Terms: React.FC = () => {
  const { t } = useTranslation()

  return (
    <div className="min-h-screen bg-background">
      <div className="max-w-3xl mx-auto px-4 py-8">
        <h1 className="text-2xl font-bold text-text mb-6">{t('footer.terms')}</h1>

        <div className="bg-white rounded-2xl shadow-sm border border-border p-6 space-y-4 text-sm text-text-secondary">
          <p>{t('terms.intro')}</p>

          <h2 className="text-lg font-semibold text-text mt-4">{t('terms.use.title')}</h2>
          <p>{t('terms.use.content')}</p>

          <h2 className="text-lg font-semibold text-text mt-4">{t('terms.ip.title')}</h2>
          <p>{t('terms.ip.content')}</p>

          <h2 className="text-lg font-semibold text-text mt-4">{t('terms.liability.title')}</h2>
          <p>{t('terms.liability.content')}</p>

          <p className="text-text-light mt-6">{t('terms.lastUpdated')}</p>
        </div>
      </div>
    </div>
  )
}

export default Terms
